import React from 'react';
import * as Icon from 'react-bootstrap-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useSpdCore } from '../../../common/hooks/useSpdCore';

export const ExamExternalReferralDeleteLink = (props: {
  examId: string | undefined;
  setRefresh?: () => void;
}) => {
  const spd = useSpdCore();

  const handleOnDelete = () => {
    if (props.examId) {
      spd.exams
        .changeToInactive(props.examId)
        .then(() => {
          if (props.setRefresh) {
            props.setRefresh();
          }
        })
        .catch(error =>
          console.log(`Wystąpił problem z usunięciem orzeczenia. ${error}`),
        );
    }
  };

  return (
    <OverlayTrigger
      overlay={
        <Tooltip style={{ position: 'fixed' }}>
          Usunięcie zleconego badania
        </Tooltip>
      }
    >
      <ConfirmationButton
        className="ms-1"
        confirmation="Czy na pewno usunąć zlecone badanie?"
        variant="btn-info"
        onOK={handleOnDelete}
      >
        <Icon.Trash />
      </ConfirmationButton>
    </OverlayTrigger>
  );
};
